import './listing.scss';
import React, { useState } from 'react';
import { AddToCartButton } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Cart/AddToCartButton';
import GatsbyImageWrapper from '@progymedia/sbi-web-occ/src/components/GatsbyImageWrapper';
import { IAppliance } from '@progymedia/sbi-web-occ/src/types';
import LocalePrice from '../../utils/LocalePrice';
import { QtyInput } from '../QtyInput';
import arrowIconWhite from '@progymedia/sbi-web-occ/src/images/icons/Icon-Fleche.svg';
import empty_star from '@progymedia/sbi-web-occ/src/images/icons/Empty_Star_Light.svg';
import full_star from '@progymedia/sbi-web-occ/src/images/icons/Full_Star_Light.svg';
import { useAvailabilityInfo } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Cart/AddToCartButton';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useProductPrice } from '@progymedia/gatsby-theme-boutik-ecommerce/src/context/store';
import { useTranslation } from 'react-i18next';
import { useProductReviews } from '../Hooks/useProductReviews';

export default function Listing(props: {
    title?: string;
    items: IAppliance[];
    isBuyable: boolean;
    displayRatings?: boolean;
    displayDescription?: boolean;
}) {
    const { currentLocale, navigateTranslated } = usePageLocalization();

    const { title, items, isBuyable, displayRatings, displayDescription } =
        props;

    return (
        <>
            <div className='occ-alist-container'>
                {title && <div className='alist-title'>{title}</div>}
                {items &&
                    items?.map((item) => (
                        <Single
                            key={item.code}
                            item={item}
                            isBuyable={isBuyable}
                            displayRatings={displayRatings}
                            displayDescription={displayDescription}
                        />
                    ))}
            </div>
        </>
    );

    function Single(props: {
        item: any;
        isBuyable: boolean;
        displayRatings?: boolean;
        displayDescription?: boolean;
    }) {
        const [qtyValue, setQtyValue] = useState(1);
        
        const { item, displayRatings, displayDescription } = props;
        const [price] = useProductPrice(item.code);
        const availability = useAvailabilityInfo(item);

        const productReviews = useProductReviews(item?.code);

        const { t } = useTranslation('pages');

        const renderStars = () => {
            let averageRating = productReviews?.average as number;
            const stars = [];
            let hasRating = false;

            for (let i = 0; i < 5; i++) {
                if (i < averageRating) {
                    hasRating = true;
                    stars.push(
                        <img
                            width={20}
                            key={`star_${i}`}
                            src={full_star}
                            alt=''
                        />
                    );
                } else {
                    stars.push(
                        <img
                            width={20}
                            key={`star_${i}`}
                            src={empty_star}
                            alt=''
                        />
                    );
                }
            }

            if (hasRating) return stars.map((star) => star);
        };

        const getPriceAndCurrency = (price: any) => {
            if (price?.regularPrice?.value) {
                return LocalePrice(currentLocale, price.regularPrice.value);
            } else {
                return '--';
            }
        };

        return (
            <div className='alist-single'>
                <div
                    className='clickable-zone'
                    onClick={() =>
                        item?.slug?.[currentLocale] &&
                        navigateTranslated(item?.slug?.[currentLocale])
                    }
                >
                    <div className='alist-image'>
                        <GatsbyImageWrapper
                            fields={item?.fields}
                            className='list-img'
                        />
                    </div>
                    <div className='alist-info'>
                        <span className='alist-sku'>{item?.code}</span>
                        <span className='alist-info-title'>
                            {item?.title?.[currentLocale]}
                        </span>
                        {item?.description && displayDescription && (
                            <span className='alist-description'>
                                {item?.description?.[currentLocale]}
                            </span>
                        )}
                        {displayRatings && (
                            <div className='alist-reviews'>
                                {renderStars()}
                                <span className='rating-count'>
                                    {`(${productReviews?.count})`}
                                </span>
                            </div>
                        )}
                    </div>
                </div>

                <div className='mobile-cart-group'>
                    {isBuyable ? (
                        <>
                            <div className='mobile-price-group'>
                                <div className='alist-price'>
                                    {getPriceAndCurrency(price)}
                                </div>
                                <div className='alist-avail'>
                                    {availability.availabilityLabel}
                                </div>
                            </div>
                            <div className='alist-add-to-cart'>
                                <QtyInput
                                    product={item}
                                    qtyValue={qtyValue}
                                    setQtyValue={setQtyValue}
                                />
                                <AddToCartButton
                                    className='add-to-cart-button'
                                    product={item}
                                    qty={qtyValue}
                                />
                            </div>
                        </>
                    ) : (
                        <div
                            className='see-details'
                            onClick={() => {
                                item?.slug?.[currentLocale] &&
                                    navigateTranslated(
                                        item?.slug?.[currentLocale]
                                    );
                            }}
                        >
                            {t('appliance.see-details')}{' '}
                            <img
                                className='arrow-icon'
                                src={arrowIconWhite}
                                alt=''
                            ></img>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
